<template>
  <header class="flex items-center w-full min-h-[28px] p-6 [@media(min-width:374px)]:px-8 sm:max-w-[600px] sm:mx-auto">
    <CNuxtImg
      class="w-[120px] sm:w-[150px]"
      alt="header-logo"
      :src="logo"
      min-height="28px"
      localize
    />
  </header>
</template>

<script setup lang="ts">
import CNuxtImg from './CNuxtImg.vue';

const props = defineProps({
  isDark: {
    type: Boolean,
    default: false,
  },
});

const logo = computed((): string => {
  return props.isDark ? 'logo_dark_bg.webp' : 'logo_white_bg.webp';
});
</script>
